  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
//import getVoucherUser     from "./handleVoucherUser";
//import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_ServiceAvailabilityService = {
  wu_serviceAvailability,
  wu_should_callServiceAvailability
};
//----------------------------------------------------------------------------------------------------
function wu_serviceAvailability(reqData) {
  const methName = "wu_serviceAvailability ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/serviceAvailability";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
    //"tokenID"                     : (localStorage.getItem("isLoggedIn")==="true") ? localStorage.getItem("tokenID")                : "9203480324982039480329920348023482308093",
    //"Authorization"               : (localStorage.getItem("isLoggedIn")==="true") ? "Bearer "+ localStorage.getItem("accessToken") : "Bearer "+localStorage.getItem("HTTP_user"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  //const data = {
  //
  //};
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      if(resData && resData.returnCode===0){
        localStorage.setItem("ServiceAvailability_RetrieveLastDate", new Date());
      }
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_should_callServiceAvailability(reqData) {
  //console.log("ServiceAvailability_RetrieveLastDate = "+new Date());
  //console.log("ServiceAvailability_RetrieveLastDate = "+localStorage.getItem("ServiceAvailability_RetrieveLastDate"));

  if(api.cache_ServiceAvailability_enabled === false){
    return true;
  }

  let UserWSRetrieveLastDate = new Date(localStorage.getItem("ServiceAvailability_RetrieveLastDate"));
  let dateNow                = new Date();
  if(UserWSRetrieveLastDate===null){
      return true;
  }
  else{
      let secondsDiff = (dateNow.getTime()-UserWSRetrieveLastDate.getTime())/1000;
      let minsDiff    = (secondsDiff/60);
      if(minsDiff<0){minsDiff = -minsDiff;}
      if(minsDiff>api.cache_ServiceAvailability_enabled){ return true;  }
      else                                              { return false; }
  }
}
//----------------------------------------------------------------------------------------------------
